// ─────────────────────────────────────────────────────────────────────────────
// FitSmith — Hyrox Trainingen
// 4 Hyrox workouts met timer-instellingen
// ─────────────────────────────────────────────────────────────────────────────

export const HYROX_TRAININGEN = [
  {
    id: "hyrox-1",
    naam: "Full Body Conditioning",
    kleur: "#3b82f6",
    kleurBg: "rgba(59,130,246,0.10)",
    kleurBorder: "rgba(59,130,246,0.25)",
    doel: "Conditie + spieruithoudingsvermogen",
    niveau: "Beginner / Gemiddeld",
    niveauKleur: "#4ade80",
    rondes: 3,
    rustTijd: 120,
    timerModus: "rondes",
    beschrijving: "Klassieke Hyrox-conditietraining. Combinatie van lopen en functionele krachtoefeningen. Focus op tempo vasthouden door alle 3 de rondes.",
    exercises: [
      {
        id: "hx1-1",
        naam: "800m Run",
        type: "afstand",
        doel_waarde: "800 meter",
        notitie: "Constant tempo. Dit is je basis-conditie voor de ronde te behouden. Adem rustig en ritmisch.",
      },
      {
        id: "hx1-2",
        naam: "Wall Balls",
        type: "reps",
        doel_waarde: "20 reps",
        notitie: "Zak diep in de squat, gooi de bal explosief naar het target. Probeer ononderbroken door te gaan.",
      },
      {
        id: "hx1-3",
        naam: "Kettlebell Swings",
        type: "reps",
        doel_waarde: "20 reps",
        notitie: "Heupen zijn de motor — niet de armen. Explosieve hip hinge. Volledig strekken bovenaan.",
      },
      {
        id: "hx1-4",
        naam: "Burpees",
        type: "reps",
        doel_waarde: "15 reps",
        notitie: "Gecontroleerd naar de grond, explosief omhoog. Behoud de techniek ook in de laatste reps.",
      },
      {
        id: "hx1-5",
        naam: "Walking Lunges",
        type: "reps",
        doel_waarde: "20 per been",
        notitie: "Grote stap voorwaarts. Achterste knie raakt de grond bijna. Romp rechtop. Wisselen per been.",
      },
      {
        id: "hx1-6",
        naam: "500m Row",
        type: "afstand",
        doel_waarde: "500 meter",
        notitie: "Trek met de benen eerst, dan de armen. Rug recht. Constante slagratio. Eindig sterk.",
      },
    ],
  },

  {
    id: "hyrox-2",
    naam: "Strength & Engine",
    kleur: "#ef4444",
    kleurBg: "rgba(239,68,68,0.10)",
    kleurBorder: "rgba(239,68,68,0.25)",
    doel: "Kracht + conditie",
    niveau: "Gemiddeld",
    niveauKleur: "#fb923c",
    rondes: 3,
    rustTijd: 150,
    timerModus: "rondes",
    beschrijving: "Combinatie van zwaar materiaal en engine-werk. Focus op krachtuithoudingsvermogen. Kan ook op 2 rondes uitgevoerd worden als je begint.",
    exercises: [
      {
        id: "hx2-1",
        naam: "Ski Erg",
        type: "afstand",
        doel_waarde: "1000 meter",
        notitie: "Trek het touw omlaag met armen én romp. Ritmische, consistente beweging. Behoud een constant watt-niveau.",
      },
      {
        id: "hx2-2",
        naam: "Sled Push",
        type: "afstand",
        doel_waarde: "30 meter",
        notitie: "Laag bij de slee. Push met de benen, niet de rug. Voorwaartse hoek — kleine, snelle stappen.",
      },
      {
        id: "hx2-3",
        naam: "Sled Pull",
        type: "afstand",
        doel_waarde: "30 meter",
        notitie: "Loop achterwaarts. Kabel strak houden. Snelle stappen, romp licht achterover.",
      },
      {
        id: "hx2-4",
        naam: "Box Step-Ups (weighted)",
        type: "reps",
        doel_waarde: "20 reps",
        notitie: "Dumbbell in elke hand. Zet de hele voet op de box. Volledig strekken bovenaan. Wissel been elke rep.",
      },
      {
        id: "hx2-5",
        naam: "Dumbbell Thrusters",
        type: "reps",
        doel_waarde: "15 reps",
        notitie: "Squat naar overhead press in één vloeiende beweging. Gebruik de beenkracht om de dumbbells omhoog te sturen.",
      },
      {
        id: "hx2-6",
        naam: "Sit-Ups",
        type: "reps",
        doel_waarde: "20 reps",
        notitie: "Voeten verankerd. Volledig omhoog, gecontroleerd terug. Handen achter het hoofd, niet trekken.",
      },
    ],
  },

  {
    id: "hyrox-3",
    naam: "Interval Blast",
    kleur: "#f59e0b",
    kleurBg: "rgba(245,158,11,0.10)",
    kleurBorder: "rgba(245,158,11,0.25)",
    doel: "Hoge intensiteit / vetverbranding",
    niveau: "Gemiddeld / Gevorderd",
    niveauKleur: "#fb923c",
    rondes: 5,
    rustTijd: 90,
    timerModus: "interval",
    beschrijving: "5 rondes hoge intensiteit met 90 seconden rust. Doel is maximale output per ronde. Perfect voor vetverbranding en conditieopbouw.",
    exercises: [
      {
        id: "hx3-1",
        naam: "400m Run",
        type: "afstand",
        doel_waarde: "400 meter",
        notitie: "Push-pace. Niet sprinten — maar snel genoeg om je adem te voelen. Behoud het tempo per ronde.",
      },
      {
        id: "hx3-2",
        naam: "Burpee Broad Jumps",
        type: "reps",
        doel_waarde: "15 reps",
        notitie: "Burpee + sprong naar voren. Zover mogelijk per sprong. Explosief van de grond af.",
      },
      {
        id: "hx3-3",
        naam: "Wall Balls",
        type: "reps",
        doel_waarde: "20 reps",
        notitie: "Ononderbroken sets. Doel is snelheid zonder techniek te verliezen. Diepe squat elke herhaling.",
      },
      {
        id: "hx3-4",
        naam: "Deadlifts",
        type: "reps",
        doel_waarde: "15 reps",
        notitie: "Matig gewicht. Rug recht op elk moment. Snelle maar gecontroleerde reps. Geen bouncing.",
      },
      {
        id: "hx3-5",
        naam: "Assault Bike",
        type: "calorie",
        doel_waarde: "20 calorieën",
        notitie: "Duw met de benen én trek/duw gelijktijdig met de armen. Maximale gecombineerde output.",
      },
    ],
  },

  {
    id: "hyrox-4",
    naam: "Race Simulatie",
    kleur: "#8b5cf6",
    kleurBg: "rgba(139,92,246,0.10)",
    kleurBorder: "rgba(139,92,246,0.25)",
    doel: "Hyrox wedstrijd nabootsen",
    niveau: "Gevorderd",
    niveauKleur: "#f87171",
    rondes: 1,
    rustTijd: 0,
    timerModus: "race",
    beschrijving: "Volledige Hyrox race-simulatie. Geen rust tenzij absoluut noodzakelijk. Registreer je split-tijden per onderdeel. Vergelijk met je vorige tijd.",
    exercises: [
      {
        id: "hx4-1",
        naam: "1 km Run",
        type: "afstand",
        doel_waarde: "1 kilometer",
        notitie: "Race-pace. Comfortabel maar op de rand. Behoud dit tempo door de hele race.",
      },
      {
        id: "hx4-2",
        naam: "Sled Push",
        type: "afstand",
        doel_waarde: "50 meter",
        notitie: "Maximale output. Lage houding, grote stappen. Geen stop — doorduwen tot het einde.",
      },
      {
        id: "hx4-3",
        naam: "1 km Run",
        type: "afstand",
        doel_waarde: "1 kilometer",
        notitie: "Herstel tijdens de run. Behoud het tempo — niet stoppen, ook al voelt het zwaar.",
      },
      {
        id: "hx4-4",
        naam: "Sled Pull",
        type: "afstand",
        doel_waarde: "50 meter",
        notitie: "Loop achterwaarts. Kabel strak houden. Snelle kleine stappen.",
      },
      {
        id: "hx4-5",
        naam: "1 km Run",
        type: "afstand",
        doel_waarde: "1 kilometer",
        notitie: "Blijf bewegen. Adem bewust. Het middenstuk is het zwaarst — push door.",
      },
      {
        id: "hx4-6",
        naam: "Wall Balls",
        type: "reps",
        doel_waarde: "40 reps",
        notitie: "Probeer ononderbroken of max 2 sets. Diepe squat. Constant tempo.",
      },
      {
        id: "hx4-7",
        naam: "1 km Run",
        type: "afstand",
        doel_waarde: "1 kilometer",
        notitie: "Push het tempo — het einde is in zicht. Verhoog je slagsnelheid.",
      },
      {
        id: "hx4-8",
        naam: "Burpees",
        type: "reps",
        doel_waarde: "30 reps",
        notitie: "Alles geven. Efficiënte beweging — niet stoppen. Dit is het moeilijkste onderdeel.",
      },
      {
        id: "hx4-9",
        naam: "1 km Run",
        type: "afstand",
        doel_waarde: "1 kilometer",
        notitie: "Laatste run. Geef het maximale dat je hebt. Sprint het laatste stuk.",
      },
      {
        id: "hx4-10",
        naam: "1000m Row",
        type: "afstand",
        doel_waarde: "1000 meter",
        notitie: "Finish sterk. Elke slag telt. Leg alles op de roeimachine. Verhoog de slagratio in de finale 200m.",
      },
    ],
  },
];
